<template>
  <div class="card" v-hover="onHoverOver">
    <div class="row">
      <div class="col-12 calendar">
        <div class="month-selection-wrapper">
          <span class="flex-spacer"></span>
          <div class="month-selection">
            <button class="btn month-nav back" @click="previousMonthClicked" type="button">
              <ArrowIcon class="icon-arrow arrow-left"/>
            </button>
            <button class="btn open-month-selector" @click="openMonthModal" type="button">
              {{ currentMonthName }}
            </button>
            <button class="btn month-nav forward" @click="nextMonthClicked" type="button">
              <ArrowIcon class="icon-arrow arrow-right"/>
            </button>
          </div>
          <div class="button-wrapper">
            <button class="btn btn-sandpiper btn-icon list-view-btn" v-hover="onHoverOverListButton" type="button"
                    @click="openListViewClicked">
              <ListIcon/>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12 days-wrapper">
            <div class="col agenda-grid-header-item">Ma</div>
            <div class="col agenda-grid-header-item">Di</div>
            <div class="col agenda-grid-header-item">Wo</div>
            <div class="col agenda-grid-header-item">Do</div>
            <div class="col agenda-grid-header-item">Vr</div>
            <div class="col agenda-grid-header-item">Za</div>
            <div class="col agenda-grid-header-item">Zo</div>
            <!--Buffer grid items before actual start of month-->
            <div class="agenda-grid-item" v-for="n in getBufferDays()" :key="n"></div>
            <AgendaGridItem
                v-for="agendaDate in agendaDates"
                v-bind:key=agendaDate.date
                v-bind:agendaDate=agendaDate
                v-on:dateClicked=dateClicked
            ></AgendaGridItem>
          </div>
        </div>
      </div>
    </div>
    <div class="legenda">
      <div class="legenda-item" v-for="item in legendaItems" :key="item.name">
        <div class="dot" :style="{'background-color': item.color}"/>
        <span> : </span>
        <span v-if="item.name === 'event'">Herinnering</span>
        <span v-if="item.name === 'more'">Beweeg meer activiteit</span>
        <span v-if="item.name === 'together'">Beweeg samen activiteit</span>
        <span v-if="item.name === 'smart'">Beweeg slim activiteit</span>
        <span v-if="item.name === 'impulse'">Beweeg tussendoor activiteit</span>


      </div>
    </div>
    <HoverInfo :show="hoveringOver" :content="'Agenda'" :offset-y="12" :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverListButton" :content="'Lijst met geplande activiteiten'" :offset-y="12"
               :offset-x="12"></HoverInfo>

  </div>
</template>

<script>
import AgendaGridItem from "@/components/Agenda/AgendaGridItem";
import log from "@/utils/logger";
import QuestTypeHelper from "@/mixins/QuestTypeHelper";
import DateComparison from "@/mixins/DateComparison";
import DateFormatter from "@/mixins/DateFormatter";

import ListIcon from "@/assets/image/icons/calendar/icon-view_list.svg?inline";
import ArrowIcon from "@/assets/image/icons/icon-arrow-alternative.svg?inline";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "AgendaContainer",
  components: {HoverInfo, AgendaGridItem, ListIcon, ArrowIcon},
  mixins: [QuestTypeHelper, DateComparison, DateFormatter],
  props: {
    currentDate: Date,
    activities: Array,
    events: Array
  },
  data: function () {
    return {
      hoveringOver: false,
      hoveringOverListButton: false,

    }
  },
  computed: {
    agendaDates() {
      let days = this.getDaysInMonth(this.currentDate.getMonth(), this.currentDate.getFullYear());
      let dateObjects = [];
      days.forEach(date => {
        let dateObj = {
          date: date,
          selected: this.isSameDay(this.currentDate, date),
          activityPips: this.getPipsForActivities(date),
        }
        dateObjects.push(dateObj);
      });
      return dateObjects;
    },
    currentMonthName() {
      return this.getMonthName(this.currentDate);
    },
    legendaItems() {
      let usedTypes = [];

      let days = this.getDaysInMonth(this.currentDate.getMonth(), this.currentDate.getFullYear());
      days.forEach(date => {

        const activitiesForDate = this.activities.filter(a => this.isSameDay(date, a.plannedDate));
        if (activitiesForDate.length > 0) {
          for (let i = 0; i < activitiesForDate.length; i++) {
            let activity = activitiesForDate[i];
            if (activity.quest) {
              if (usedTypes.findIndex(type => type.name === activity.quest.type) === -1) {
                usedTypes.push({
                  name: activity?.quest?.type,
                  color: this.questTypeColor(activity?.quest?.type)
                });
              }

            }
          }
        }


        const eventsForDate = this.events ? this.events.filter(e => this.isSameDay(date, e.date)) : [];
        eventsForDate.forEach(e => {
          log.debug(e);
          if (usedTypes.findIndex(type => type.name === "event") === -1) {
            usedTypes.push({
              name: "event",
              color: "#BEBEBE"
            })
          }
        });

      });
      return usedTypes;
    }
  },
  methods: {
    dateClicked(agendaDate) {
      log.info("[AgendaContainer] date clicked: " + agendaDate)
      this.$emit("dateChanged", agendaDate);
    },
    previousMonthClicked() {
      let newDate = this.currentDate;
      newDate.setMonth(newDate.getMonth() - 1);
      this.dateClicked(newDate);
    },
    nextMonthClicked() {
      let newDate = this.currentDate;
      newDate.setMonth(newDate.getMonth() + 1);
      this.dateClicked(newDate);
    },
    openMonthModal() {
      this.$emit("openMonthModalClicked");
    },
    openListViewClicked() {
      this.$emit("openListViewClicked");
    },
    //probably won't be necessary as we'll need to get a list of days in a month to populate the activity pips anyway
    //also, maybe just use moment.js
    getDaysInMonth(month, year) {
      let date = new Date(year, month, 1);
      let days = [];
      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }
      return days;
    },
    getFirstDayOfMonth(month, year) {
      return new Date(year, month, 1).getDay();
    },
    getBufferDays() {
      let firstDayOfMonth = this.getFirstDayOfMonth(this.currentDate.getMonth(), this.currentDate.getFullYear());
      return firstDayOfMonth === 0 ? 6 : firstDayOfMonth - 1;
    },
    getPipsForActivities(date) {
      let pips = [];
      const activitiesForDate = this.activities.filter(a => this.isSameDay(date, a.plannedDate));
      const eventsForDate = this.events ? this.events.filter(e => this.isSameDay(date, e.date)) : [];

      for (let i = 0; i < activitiesForDate.length; i++) {
        let activity = activitiesForDate[i];
        pips.push({
          id: activity.id,
          color: this.questTypeColor(activity.quest.type)
        });
      }

      eventsForDate.forEach(e => {
        pips.push({
          id: `event-${e.id}`,
          color: "#BEBEBE"
        })
      });

      return pips;
    },
    onHoverOver(state) {
      this.hoveringOver = state;
    },
    onHoverOverListButton(state) {
      this.hoveringOverListButton = state;
    }


  },
  created() {
    if (this.currentDate == null) {
      log.info("[AgendaContainer] currentDate was null");
    }
  }
}
</script>

<style lang="scss" scoped>

.container {
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
}

.title {
  font-size: 1.25rem;
}

.days-wrapper {
  display: grid;
  //grid-template-columns: repeat(7, minmax(20px, 1fr));
  //gap: 10px;
  grid-template-columns: repeat(7, calc(100% / 7));
  grid-auto-rows: 1fr;
}

.agenda-grid-header-item {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0px;
  padding-right: 0px;
  color: $font-grey;
}

.month-selection-wrapper {
  display: flex;
  //padding-left: 50px;
  justify-content: center;
  margin-bottom: 30px;

  .flex-spacer {
    flex: 1;
  }

  .button-wrapper {
    flex: 1;
    text-align: right;
  }
}

.icon-arrow {
  fill: $primary-blue;

  &.arrow-right {
    transform: rotate(-90deg);
  }

  &.arrow-left {
    transform: rotate(90deg);
  }
}

.month-selection {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex: 1 0 auto;

  .month-nav {
    color: $primary-blue;

    .back {

    }

    .forward {

    }
  }

  .open-month-selector {
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    color: $font-dark;
    font-weight: bold;
    font-size: $title-size;
    padding: 0.375rem 1rem;
    display: flex;

  }

  .add-button-wrapper {
    align-self: flex-end;
  }
}

.btn-icon {
  padding: 18px 13px 17px;
  line-height: 0;

  svg {
    fill: $font-light;
  }

  &.list-view-btn {
    height: 100%;
  }
}

.legenda {
  width: 100%;
  display: flex;
  flex-direction: column;

  .legenda-item {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 5px;

    .dot {
      border-radius: 50%;
      width: 8px;
      height: 8px;
    }

    span {

    }
  }
}
</style>